import { useState } from '#imports'

export const useScrollState = () => {
  const scrollState = useState('useScrollState:scrollState', () => ({
    isScrolledDown: false,
  }))
  const handleScrollInElement = (event: { direction: 'up' | 'down' }) => {
    const { direction } = event

    if (direction === 'down') {
      scrollState.value.isScrolledDown = true
    } else {
      scrollState.value.isScrolledDown = false
    }
  }

  return {
    scrollState,
    handleScrollInElement,
  }
}
